import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Scroll } from 'vuetify/lib/directives'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify, {
  directives: {
    Scroll
  }
})

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#320359',
        accent: '#F7F5F5',
        secondary: '#FFFFFF',
        success: '#52088F',
        info: '#e97500',
        warning: '#F1852F',
        error: '#000000'
      }
    }
  },
  icons: {
    iconfont: 'fa'
  }
})
